import { Dropdown } from "@kitbird/core";
import { useEffect } from "react";
import { DropdownProps, FilterDropdownProps } from "./FilterDropdown.type";
import { DropdownWrapper } from "./FilterDropdown.style";

const FilterDropdown = ({
  value,
  options,
  onSelected,
  width,
  disable,
  ...props
}: FilterDropdownProps & DropdownProps & React.RefAttributes<HTMLInputElement>) => {
  useEffect(() => {
    if (options.length === 1 && onSelected) {
      onSelected(options[0]);
    }
  }, [options.length]);
  const isDisabled = (options.length === 1 && typeof disable === "undefined") || disable;
  return (
    <DropdownWrapper $width={width || "120px"} $disabled={isDisabled}>
      <Dropdown
        className="dropdown-filter"
        value={options.length === 1 && !value ? options[0].label : value}
        onSelected={onSelected}
        options={options}
        disabled={isDisabled}
        {...props}
      />
    </DropdownWrapper>
  );
};

export default FilterDropdown;
